var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-row',{staticClass:"container"},[_c('WorkOrderFilters',{model:{value:(_vm.filters),callback:function ($$v) {_vm.filters=$$v},expression:"filters"}}),_c('br'),_c('el-button',{attrs:{"type":"success"},on:{"click":_vm.search}},[_c('strong',{staticClass:"white"},[_vm._v("Search")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }